module.exports = require("vue-router");